<template>
	<MultiSelect ref="multiSelect" v-bind="props" :show-toggle-all="false" @update:model-value="value => emit('update:modelValue', value)">
		<template #header>
			<div class="p-multiselect-header p-multiselect-option" v-if="showSelectAll">
				<label for="SelectAll">{{ allSelected ? 'Deselect All' : 'Select All' }}</label>
				<Checkbox v-model="allSelected" binary inputId="SelectAll" />
			</div>
		</template>
		<template #value="slotProps"><slot name="value" v-bind="slotProps"></slot></template>
		<template #chip="slotProps"><slot name="chip" v-bind="slotProps"></slot></template>
		<template #option="slotProps"><slot name="option" v-bind="slotProps"></slot></template>
	</MultiSelect>
</template>

<script lang="ts" setup>
	import { resolveFieldData } from '@primeuix/utils/object';
	import { Checkbox, MultiSelect, type MultiSelectProps } from 'primevue';
	import { computed, ref } from 'vue';

	const multiSelect = ref<typeof MultiSelect>();
	const props = defineProps<MultiSelectProps>();

	const emit = defineEmits(['update:modelValue']);

	function getOptionValue(option: unknown) {
		return props.optionValue ? resolveFieldData(option, props.optionValue) : option;
	}

	function getOptionDisabled(option: unknown) {
		return props.optionDisabled ? resolveFieldData(option, props.optionDisabled) : false;
	}

	const showSelectAll = computed(() => (props.options ?? []).map(getOptionDisabled).filter(x => !x).length > 1);

	const allSelected = computed<boolean>({
		get: () => props.modelValue.length == props.options?.length,
		set: value => {
			if (value) {
				emit('update:modelValue', props.options?.map(getOptionValue));
			} else {
				emit('update:modelValue', []);
			}
		},
	});
</script>
